import { useLayoutEffect } from "react";

/**
 * Hide the background-jobs label (`#react-jobs-body-root`, the deprecated `TaskRunner`'s
 * debug mount) while `shouldHide` is true and restore it on unmount. It is server-rendered
 * chrome pinned to `bottom: 10px; left: 10px`, so on the full-viewport wizard pages it
 * lands on top of the Exit Wizard button. Pages that show their own waiting state don't
 * need the label, so they hide it rather than leaving room for it. (PY-12570)
 */
export const useHideBackgroundJobsWatcher = (shouldHide: boolean): void => {
	useLayoutEffect(() => {
		if (!shouldHide) return;
		const watcher = document.getElementById("react-jobs-body-root");
		if (!watcher) return;
		watcher.style.display = "none";
		return () => {
			watcher.style.display = "";
		};
	}, [shouldHide]);
};
